export default __webpack_public_path__ + "static/media/PreRoleSpotInstanceData.02f0ffd5.md";